import { clamp as getClamp } from 'lib/helpers';

export function getElProgress({ windowHeight, scrollTop, elHeight, elTop, clamp = true }) {
	const topOffset = elTop - windowHeight;
	const overflow = topOffset + windowHeight + elHeight;
	const progress = (scrollTop - topOffset) / (overflow - topOffset);
	if (!clamp) {
		return progress;
	}
	return getClamp(progress, -0.001, 1.001);
}

export function interoplateToCenter(progress, isOneAt = 0.5) {
	return 1 - Math.abs(isOneAt - progress) * 2;
}
